import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Calendar, MapPin } from 'lucide-react';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import { Button } from '../components/ui/button';
import { useLanguage } from '../context/LanguageContext';

const newsDetailData = {
  1: {
    titleTr: 'Üniversite Öğrencileri İçin "Am I Safe?" Semineri Düzenlendi',
    titleEn: '"Am I Safe?" Seminar Organized for University Students',
    subtitleTr: 'Projenin yaygınlaştırma faaliyetleri kapsamında dijital teknolojiler alanında eğitim gören üniversite öğrencileri için Am I Safe? semineri düzenlendi.',
    subtitleEn: 'As part of the project dissemination activities, an "Am I Safe?" seminar was organized for university students studying digital technologies.',
    contentTr: `Projenin yaygınlaştırma faaliyetleri kapsamında, dijital teknolojiler alanında eğitim gören üniversite öğrencilerine yönelik "Am I Safe?" başlıklı bir seminer gerçekleştirildi. Etkinlikte, gençlerin dijital dünyada karşılaşabilecekleri siber riskler, kişisel veri güvenliği ve güvenli internet kullanımı gibi konular ele alındı.

Seminer süresince öğrencilere, günlük yaşamlarında maruz kalabilecekleri siber tehditlere karşı farkındalık kazandırmayı amaçlayan örnekler, vaka analizleri ve uygulamalı anlatımlar sunuldu. Katılımcılar ayrıca güvenli şifre oluşturma, sosyal medya gizlilik ayarları ve çevrim içi güvenlik araçlarının kullanımı konusunda bilgilendirildi.

Etkinlik sonunda öğrenciler, edindikleri bilgiler doğrultusunda sorularını paylaşma ve deneyim alışverişinde bulunma fırsatı yakaladı. "Am I Safe?" seminerlerinin, proje kapsamında farklı hedef gruplarla yaygınlaştırılarak devam etmesi planlanıyor.`,
    contentEn: `As part of the project dissemination activities, an "Am I Safe?" seminar was conducted for university students studying digital technologies. The event addressed topics such as cyber risks that young people may encounter in the digital world, personal data security, and safe internet usage.

During the seminar, participants were presented with examples, case analyses, and practical demonstrations aimed at raising awareness about cyber threats they may face in their daily lives. Participants were also informed about creating secure passwords, social media privacy settings, and the use of online security tools.

At the end of the event, students had the opportunity to share their questions and exchange experiences based on the information they acquired. It is planned to continue the "Am I Safe?" seminars by disseminating them to different target groups within the scope of the project.`,
    dateTr: '20 Aralık 2024',
    dateEn: 'December 20, 2024',
    location: 'Zonguldak',
    images: [
      'https://customer-assets.emergentagent.com/job_cyberyouth/artifacts/yeh5v9aw_1-1.jpg',
      'https://customer-assets.emergentagent.com/job_cyberyouth/artifacts/rjq8jnt2_1-2.jpg',
      'https://customer-assets.emergentagent.com/job_cyberyouth/artifacts/letn9k4v_1-3.jpeg',
      'https://customer-assets.emergentagent.com/job_cyberyouth/artifacts/arggnpvh_1-4.jpeg',
      'https://customer-assets.emergentagent.com/job_cyberyouth/artifacts/m7s96d05_1-5.jpeg',
    ],
  },
  2: {
    titleTr: '"Kişisel Verileriniz Ne Kadar Güvende?" Projesi Kapsamında Konferans Düzenlendi',
    titleEn: 'Conference Held Within "How Safe Is Your Personal Data?" Project',
    subtitleTr: 'Erasmus+ KA210-Youth programı kapsamında yürütülen proje çerçevesinde, kişisel veri güvenliği ve dijital farkındalık temalı bir konferans gerçekleştirildi.',
    subtitleEn: 'A conference on personal data security and digital awareness was organized within the framework of the Erasmus+ KA210-Youth program.',
    contentTr: `Erasmus+ KA210-Youth programı kapsamında yürütülen "Kişisel Verileriniz Ne Kadar Güvende?" başlıklı proje çerçevesinde, kişisel veri güvenliği ve dijital farkındalık temalı bir konferans gerçekleştirildi. Etkinlikte, gençlerin dijital dünyada karşılaşabilecekleri veri ihlalleri, siber riskler ve güvenli çevrim içi davranışlar üzerine kapsamlı sunumlar yapıldı.

Konferansta, katılımcılara kişisel verilerin korunması, sosyal medya ve çevrim içi platformlarda gizlilik ayarları, güçlü parola kullanımı ve siber tehditlere karşı bireysel önlem alma yöntemleri üzerine örnekler ve uygulamalı anlatımlar sunuldu. Ayrıca veri güvenliği alanındaki güncel gelişmeler ve iyi uygulama örnekleri paylaşıldı.

Etkinlik, gençlerin dijital güvenlik farkındalığını artırmayı, bilinçli teknoloji kullanımını teşvik etmeyi ve proje kapsamında geliştirilecek eğitim çıktılarının yaygınlaştırılmasını amaçladı. Konferansın sonunda katılımcılar soru-cevap oturumunda görüş ve katkılarını paylaştı.`,
    contentEn: `A conference on personal data security and digital awareness was held within the framework of the "How Safe Is Your Personal Data?" project conducted under the Erasmus+ KA210-Youth program. The event featured comprehensive presentations on data breaches, cyber risks, and safe online behaviors that young people may encounter in the digital world.

At the conference, participants were presented with examples and practical demonstrations on protecting personal data, privacy settings on social media and online platforms, using strong passwords, and individual measures against cyber threats. Additionally, current developments in data security and best practice examples were shared.

The event aimed to increase young people's awareness of digital security, encourage conscious use of technology, and disseminate educational outputs to be developed within the scope of the project. At the end of the conference, participants shared their opinions and contributions in a Q&A session.`,
    dateTr: '14 Ocak 2025',
    dateEn: 'January 14, 2025',
    location: 'Zonguldak',
    images: [
      'https://customer-assets.emergentagent.com/job_secyouth/artifacts/anpbygnx_2-1.webp',
      'https://customer-assets.emergentagent.com/job_secyouth/artifacts/tnndjpuj_2-2.jpeg',
      'https://customer-assets.emergentagent.com/job_secyouth/artifacts/7lnh5juj_2-3.jpg',
      'https://customer-assets.emergentagent.com/job_secyouth/artifacts/j250tfo1_2-4.jpg',
    ],
  },
  3: {
    titleTr: '"Güvende Miyim?" Platformu Liseli Gençlere Tanıtıldı',
    titleEn: '"Am I Safe?" Platform Introduced to High School Students',
    subtitleTr: 'Erasmus+ KA210 programı kapsamında geliştirilen "Güvende Miyim?" Platformu, liselerde eğitim gören gençlere tanıtıldı.',
    subtitleEn: 'The "Am I Safe?" Platform, developed under the Erasmus+ KA210 program, was presented to high school students.',
    contentTr: `Erasmus+ KA210 programı kapsamında geliştirilen "Güvende Miyim?" Platformu, liselerde eğitim gören gençlere tanıtıldı. Tanıtım etkinliği kapsamında öğrencilere dijital güvenlik, kişisel veri koruma bilinci ve güvenli internet kullanımı konularında farkındalık kazandırmayı amaçlayan bilgilendirme sunumları gerçekleştirildi.

Platformun işleyişi, içerik yapısı ve gençlere sunduğu dijital güvenlik araçları hakkında katılımcılara örnek uygulamalarla bilgi verildi. Öğrenciler; siber tehdit türleri, güvenli şifre oluşturma, sosyal medya gizlilik ayarları ve çevrim içi davranış güvenliği gibi başlıklarda pratik önerilerle desteklendi.

Etkinlik süresince öğrencilerin soruları yanıtlandı ve platformun gençlerin dijital yaşamlarında aktif bir güvenlik rehberi olarak kullanılması teşvik edildi. Tanıtım çalışmalarının, proje kapsamında farklı okullarda ve gençlik gruplarında yaygınlaştırılarak devam etmesi planlanıyor.`,
    contentEn: `The "Am I Safe?" Platform, developed under the Erasmus+ KA210 program, was introduced to high school students. As part of the promotional event, informational presentations were delivered aimed at raising awareness among students about digital security, personal data protection, and safe internet usage.

Participants were provided with information about the platform's functionality, content structure, and digital security tools it offers to young people through sample applications. Students were supported with practical advice on topics such as types of cyber threats, creating secure passwords, social media privacy settings, and online behavior safety.

During the event, students' questions were answered, and the use of the platform as an active security guide in young people's digital lives was encouraged. It is planned to continue the promotional activities by disseminating them to different schools and youth groups within the scope of the project.`,
    dateTr: '2 Şubat 2025',
    dateEn: 'February 2, 2025',
    location: 'Zonguldak',
    images: [
      'https://customer-assets.emergentagent.com/job_cyberyouth/artifacts/n7nczbmc_3-1.webp',
      'https://customer-assets.emergentagent.com/job_secyouth/artifacts/ouil767e_3-2.webp',
      'https://customer-assets.emergentagent.com/job_secyouth/artifacts/8yue3nhg_3-3.webp',
      'https://customer-assets.emergentagent.com/job_secyouth/artifacts/viu7rcfp_3-4.jpeg',
      'https://customer-assets.emergentagent.com/job_secyouth/artifacts/ynw0l8mz_3-5.jpeg',
      'https://customer-assets.emergentagent.com/job_secyouth/artifacts/ekfnf8zi_3-6.jpeg',
    ],
  },
  4: {
    titleTr: 'Çok Uluslu Siber Güvenlik Platformu Geliştiriliyor',
    titleEn: 'Multinational Cybersecurity Platform Under Development',
    subtitleTr: 'Avrupa Birliği tarafından finanse edilen "How Safe Is Your Personal Data" projesi kapsamında çok uluslu bir siber güvenlik platformu hazırlanıyor.',
    subtitleEn: 'A multinational cybersecurity platform is being developed within the EU-funded "How Safe Is Your Personal Data" project.',
    contentTr: `Siber Güvenlik Projesi Kapsamında Çok Uluslu Bir Platform Hazırlanıyor. Avrupa Birliği tarafından finanse edilen ve Türkiye Ulusal Ajansı'nın koordinasyonunu sağladığı, "KA210 – Small-Scale Partnership in Youth" ana başlığında ve Batı Karadeniz Kalkınma Ajansının ortağı olduğu projenin ilk toplantısı Zonguldak'ta gerçekleştirildi.

Ülkemizde Erasmus+ Programı kapsamında Ulusal Ajans tarafından desteklenen siber güvenlik projelerinden birisi olarak ayrı bir öneme sahip olan "How Safe Is Your Personal Data - Kişisel Verileriniz Ne Kadar Güvende?" adlı proje Zonguldak'ta Siber Vatan Programı gençleri tarafından yürütülüyor.

Proje koordinatörlüğünü Siber Vatan Programında yer alan uzmanlarının oluşturduğu Siber Güvenlik Araştırmacıları ve Gençlik Derneği yürütürken projenin ilk toplantısının ev sahipliğini proje ortaklarından Batı Karadeniz Kalkınma Ajansı (BAKKA) yaptı.

Projenin açılış toplantısına projenin diğer ortaklarından olan Almanya ve İspanya'dan siber güvenlik uzmanları katılım sağladı. Siber güvenlik konusunun küresel olarak değerlendirildiği toplantılarda, gelişen siber saldırı teknikleri, siber saldırıların ülkelere verdiği zararlar ile bu saldırıların sosyal boyutları irdelenerek proje kapsamında oluşturulacak platform sisteminin yol haritası belirlendi.

Proje kapsamında geliştirilecek bu platform ile bireylerin ihtiyaç duyabileceği siber güvenlik araçlarının tek bir internet sitesinde toplanması, basitleştirilerek kullanıcıların kendi siber güvenliklerinin artırılmasına katkı amaçlanıyor.

Proje toplantılarının açılışında Batı Karadeniz Kalkınma Ajansı Genel Sekreteri Dr. Lutfi ALTUNSU siber güvenlik alanında genç bireylerin yetiştirilmesinin önemine vurgu yaparak yeni ve yenilikçi çalışmalara hız verilmesinin önemini belirtti.

Projenin ortağı olan Siber Güvenlik Araştırmacıları ve Gençlik Derneği'nin proje koordinatörü Sibel Temli insanların dijital dünyada varlıklarını sürdürmeye devam ederken bir yandan da siber güvenliklerini sağlamak zorunda olduklarını ifade etti.`,
    contentEn: `A Multinational Platform is Being Developed Within the Cybersecurity Project. The first meeting of the project, financed by the European Union and coordinated by the Turkish National Agency, under the main title of "KA210 – Small-Scale Partnership in Youth" and with the Western Black Sea Development Agency as a partner, was held in Zonguldak.

The project titled "How Safe Is Your Personal Data," which holds special importance as one of the cybersecurity projects supported by the National Agency under the Erasmus+ Program in our country, is being carried out by the youth of the Siber Vatan Program in Zonguldak.

While the Cybersecurity Researchers and Youth Association, consisting of experts from the Siber Vatan Program, is coordinating the project, the Western Black Sea Development Agency (BAKKA), one of the project partners, hosted the first meeting of the project.

Cybersecurity experts from Germany and Spain, other partners of the project, participated in the opening meeting. In meetings where cybersecurity was evaluated globally, evolving cyber attack techniques, damages caused by cyber attacks to countries, and social dimensions of these attacks were examined, and the roadmap for the platform system to be created within the scope of the project was determined.

With this platform to be developed within the scope of the project, it is aimed to collect cybersecurity tools that individuals may need on a single website, simplify them, and contribute to increasing users' own cybersecurity.

At the opening of the project meetings, Dr. Lutfi ALTUNSU, Secretary General of the Western Black Sea Development Agency, emphasized the importance of training young individuals in the field of cybersecurity and stated the importance of accelerating new and innovative work.

Sibel Temli, project coordinator of the Cybersecurity Researchers and Youth Association, a partner of the project, stated that people must ensure their cybersecurity while continuing to exist in the digital world.`,
    dateTr: '8 Şubat 2025',
    dateEn: 'February 8, 2025',
    location: 'Zonguldak',
    images: [
      'https://customer-assets.emergentagent.com/job_secyouth/artifacts/s2c8bn56_4-1.jpeg',
      'https://customer-assets.emergentagent.com/job_secyouth/artifacts/cinux7ta_4-2.webp',
      'https://customer-assets.emergentagent.com/job_secyouth/artifacts/nhri3mzu_4-3.jpg',
    ],
  },
};

const NewsDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { language } = useLanguage();

  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  const news = newsDetailData[id];

  if (!news) {
    return (
      <div className="min-h-screen bg-[#060b1a] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl text-white mb-4">
            {language === 'tr' ? 'Haber bulunamadı' : 'News not found'}
          </h1>
          <Button onClick={() => navigate('/')} className="bg-[#4DFF88] text-[#060b1a]">
            {language === 'tr' ? 'Ana Sayfaya Dön' : 'Back to Home'}
          </Button>
        </div>
      </div>
    );
  }

  const title = language === 'tr' ? news.titleTr : news.titleEn;
  const subtitle = language === 'tr' ? news.subtitleTr : news.subtitleEn;
  const content = language === 'tr' ? news.contentTr : news.contentEn;
  const date = language === 'tr' ? news.dateTr : news.dateEn;

  return (
    <div className="min-h-screen bg-[#060b1a]">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-12 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-[#060b1a] via-[#0a1628] to-[#0f1f33]" />
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#4DFF88]/10 rounded-full blur-[150px]" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-[#4DD6FF]/10 rounded-full blur-[120px]" />
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Back Button */}
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-gray-400 hover:text-[#4DFF88] transition-colors mb-8"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>{language === 'tr' ? 'Geri Dön' : 'Go Back'}</span>
          </button>

          {/* Meta Info */}
          <div className="flex items-center gap-4 mb-6">
            <div className="flex items-center gap-2 text-[#4DFF88]">
              <Calendar className="w-4 h-4" />
              <span className="text-sm">{date}</span>
            </div>
            <div className="flex items-center gap-2 text-[#4DD6FF]">
              <MapPin className="w-4 h-4" />
              <span className="text-sm">{news.location}</span>
            </div>
          </div>

          {/* Title */}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-white leading-tight mb-6">
            {title}
          </h1>

          {/* Subtitle */}
          <p className="text-xl text-gray-300 leading-relaxed">
            {subtitle}
          </p>
        </div>
      </section>

      {/* Main Image */}
      <section className="relative py-8 bg-[#060b1a]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="rounded-2xl overflow-hidden border border-white/10">
            <img
              src={news.images[0]}
              alt={title}
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="relative py-12 bg-[#060b1a]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg prose-invert max-w-none">
            {content.split('\n\n').map((paragraph, index) => (
              <p key={index} className="text-gray-300 leading-relaxed mb-6 text-lg">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </section>

      {/* Image Gallery */}
      {news.images.length > 1 && (
        <section className="relative py-12 bg-[#060b1a]">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-semibold text-white mb-8">
              {language === 'tr' ? 'Etkinlik Fotoğrafları' : 'Event Photos'}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {news.images.slice(1).map((image, index) => (
                <div
                  key={index}
                  className="rounded-xl overflow-hidden border border-white/10 hover:border-[#4DFF88]/30 transition-all duration-300 group"
                >
                  <img
                    src={image}
                    alt={`${title} - ${index + 2}`}
                    className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Back to News CTA */}
      <section className="relative py-12 bg-[#060b1a]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Button
            onClick={() => navigate('/#news')}
            className="bg-[#4DFF88] hover:bg-[#4DFF88]/10 hover:text-[#4DFF88] text-[#060b1a] font-medium px-8 py-4 rounded-none transition-all duration-300"
          >
            {language === 'tr' ? 'Tüm Haberlere Dön' : 'Back to All News'}
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NewsDetailPage;
